/**
 * EntryScreen styles — extracted to keep the screen component under 500 lines.
 */
import { ImageStyle, TextStyle, ViewStyle } from "react-native"

import { colors, spacing, typography } from "@/theme"

// ── Layout ────────────────────────────────────────────────────────────────────

export const $container: ViewStyle = {
  flex: 1,
  position: "relative",
  backgroundColor: colors.background,
  height: "100vh" as any,
  width: "100%",
}

export const $mapContainer: ViewStyle = {
  position: "absolute",
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  zIndex: 0,
}

export const $contentContainer: ViewStyle = {
  flex: 1,
  justifyContent: "center",
  alignItems: "center",
  paddingHorizontal: spacing.xl,
  maxWidth: 480,
  width: "100%",
  alignSelf: "center",
  zIndex: 10,
}

export const $contentContainerMobile: ViewStyle = { paddingHorizontal: spacing.md }

export const $form: ViewStyle = {
  width: "100%",
  backgroundColor: colors.surface,
  borderRadius: 16,
  padding: spacing.xl,
  shadowColor: colors.palette.neutral900,
  shadowOffset: { width: 0, height: 4 },
  shadowOpacity: 0.15,
  shadowRadius: 16,
  elevation: 6,
}

export const $footer: ViewStyle = {
  position: "absolute",
  bottom: 0,
  left: 0,
  right: 0,
  zIndex: 2000,
}

// ── Choice View ───────────────────────────────────────────────────────────────

export const $logoContainer: ViewStyle = { alignItems: "center", marginBottom: spacing.md }

export const $logo: ImageStyle = { width: 280, height: 140 }

export const $divider: ViewStyle = {
  height: 1,
  backgroundColor: colors.border,
  marginBottom: spacing.md,
}

export const $choiceButton: ViewStyle = {
  backgroundColor: colors.primary,
  borderRadius: 12,
  paddingVertical: spacing.md,
  paddingHorizontal: spacing.lg,
  marginBottom: spacing.sm,
}

export const $choiceButtonOutline: ViewStyle = {
  backgroundColor: colors.surface,
  borderWidth: 2,
  marginBottom: 0,
  borderColor: colors.background,
}

export const $choiceButtonInner: ViewStyle = {
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "space-between",
}

export const $choiceButtonTextWrap: ViewStyle = { flex: 1 }

export const $choiceButtonTitle: TextStyle = {
  fontSize: 16,
  fontWeight: "700",
  color: colors.palette.neutral100,
}

export const $choiceButtonTitleDark: TextStyle = { color: colors.background }

export const $choiceButtonSubtitle: TextStyle = {
  fontSize: 13,
  color: "rgba(255,255,255,0.8)",
  marginTop: 2,
}

export const $choiceButtonSubtitleDark: TextStyle = { color: colors.textDim }

// ── Shared ───────────────────────────────────────────────────────────────────

export const $backRow: ViewStyle = {
  flexDirection: "row",
  alignItems: "center",
  marginBottom: spacing.md,
}

export const $backLabel: TextStyle = {
  fontSize: 14,
  color: colors.textDim,
  marginLeft: spacing.xs,
}

export const $formTitle: TextStyle = {
  fontSize: 18,
  fontWeight: "700",
  color: colors.text,
  marginBottom: spacing.lg,
}

export const $input: ViewStyle & TextStyle = {
  height: 56,
  borderWidth: 1,
  borderColor: colors.border,
  borderRadius: 8,
  paddingHorizontal: spacing.md,
  fontSize: 16,
  color: colors.text,
  backgroundColor: colors.surface,
  fontFamily: typography.primary.normal,
}

export const $errorContainer: ViewStyle = {
  backgroundColor: colors.errorBackground,
  borderRadius: 8,
  padding: spacing.md,
  marginTop: spacing.sm,
}

export const $errorText: TextStyle = {
  fontSize: 14,
  color: colors.palette.neutral100,
  textAlign: "center",
}

export const $primaryButton: ViewStyle = {
  marginTop: spacing.md,
  backgroundColor: colors.primary,
  borderWidth: 0,
}

export const $primaryButtonText: TextStyle = {
  color: colors.palette.neutral100,
}

export const $secondaryButton: ViewStyle = {
  marginTop: spacing.md,
  backgroundColor: colors.palette.neutral800,
  borderWidth: 1,
  borderColor: colors.palette.neutral800,
}

export const $secondaryButtonText: TextStyle = {
  color: colors.palette.neutral100,
}

// ── Booking Link ─────────────────────────────────────────────────────────────

export const $bookingLink: TextStyle = {
  fontSize: 13,
  color: colors.textDim,
  textAlign: "center",
  marginTop: spacing.lg,
}

export const $bookingLinkHighlight: TextStyle = {
  fontSize: 13,
  color: colors.primary,
  fontWeight: "600",
  textDecorationLine: "underline",
}

// ── Success Animation ────────────────────────────────────────────────────────

export const $successContainer: ViewStyle = {
  alignItems: "center",
  paddingVertical: spacing.lg,
}

export const $successCheckCircle: ViewStyle = {
  width: 64,
  height: 64,
  borderRadius: 32,
  backgroundColor: colors.primary,
  alignItems: "center",
  justifyContent: "center",
  marginBottom: spacing.lg,
}

export const $successCheckMark: TextStyle = {
  fontSize: 30,
  color: colors.palette.neutral100,
  fontWeight: "700",
}

export const $successTitle: TextStyle = {
  fontSize: 20,
  fontWeight: "700",
  color: colors.text,
  textAlign: "center",
  marginBottom: spacing.xs,
}

export const $successText: TextStyle = {
  fontSize: 14,
  color: colors.textDim,
  textAlign: "center",
  lineHeight: 20,
}
